<template>
  <el-config-provider :locale="locale">
    <div class="ys_main">
      <div class="ys_box">
        <div class="ys_title">风险提示</div>
        <div class="ys_content">
           <p class="ys_h3">尊敬的用户：</p>
           <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海悦宝互联网金融信息服务股份有限公司网站服务及模拟交易软件，提供两类服务。第一类为客观数据加工服务，利用自研算法生成资金流向数据，不涉及任何形式的投资顾问、投资咨询及资产配置服务，所有功能仅限于市场数据的整合计算与可视化展示。数据结果、图表、标识、信号、参考等均不构成投资建议、决策依据。数据服务受限于自身算法，不可避免的存在专业局限性、设计不足及由此带来的数据使用风险。由于信息系统算力、设备性能瓶颈、程序故障可能导致数据服务延迟、中断，出现无法提供数据服务的问题。第二类，模拟交易软件及仿真交易环境仅为公开数据进行加工展示，我们不保证基础数据的及时性、准确性、真实性、完整性、连续性，不承担因任何数据不准确或遗漏等造成的模拟交易错误或偏差问题。</p>
           <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户完全知悉并接受上海悦宝互联网金融信息服务股份有限公司网站服务所提供的数据算法的专业局限性、设计不足及由此带来的数据使用风险。用户完全知悉并接受由于信息系统算力、设备性能瓶颈、程序故障导致的数据及模拟交易服务延迟、中断、无法提供数据服务的负面影响和结果。</p>



        </div>


      </div>

    </div>


  </el-config-provider>
</template>
<script>

import zhCn from "element-plus/lib/locale/lang/zh-cn";


export default {
  components: {},
  data() {
    return {
      locale: zhCn,
    };
  },
  methods: {


  }
};

</script>

<style scoped>
.ys_main {
  background-color: #fff;
  width: 100%;
  height: 100%;
}
.ys_box{
  padding: 50px 15%;
}

.ys_title{
  text-align: center;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 20px;
}

.ys_content{
  color: #040404;
  font-size: 14px;
  line-height: 24px;
  white-space: pre-wrap;
}

.ys_content p{
  margin: 8px 0 0 0;
}

.ys_h2{
  margin: 18px 0 6px 0;
  font-weight: 600;
}

.ys_h3{
  margin: 12px 0 4px 0;
  font-weight: 500;
}

.us_test {
  display: block;
  font-weight: 400;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 15px;
}


</style>
